import {
  IContractTemplateTreeItemForm,
  IDistributionResponse,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import { contractTemplateUtil } from 'utils';
import { connectTemplateTreeItems } from '../templateQueryItemsConnector';

export const merchDistributionTemplateQueryToForm = (
  distribution: IDistributionResponse,
  lowestAvailableId?: string,
  disabledSelection = false,
  disabledRemove = false
): IContractTemplateTreeItemForm[] => {
  const [merchDistribution] = connectTemplateTreeItems(
    {
      merchDistribution: { ...distribution, position: 0 },
    },
    lowestAvailableId ?? '1'
  );

  const merchDistributionForm: IContractTemplateTreeItemForm = {
    ...merchDistribution,
    disabledSelection: disabledSelection,
    disabledRemove: disabledRemove,
  };

  return contractTemplateUtil.distribution.initialValues(
    TEMPLATE_TYPE.merchDistribution,
    [merchDistributionForm]
  );
};
